var configureBuyerName = function (buyerName) {
    if (buyerName && buyerName.length > 25) {
        var cutSection = buyerName.slice(0, 25);
        return "".concat(cutSection, "...");
    }
    return buyerName;
};
var deaultBuyerElement = function (buyerName, buyerId) {
    return "".concat(configureBuyerName(buyerName) || '', "- ").concat(buyerId || '');
};
var createBuyerElement = function (buyerName, buyerId) {
    if (buyerName && !buyerId) {
        return buyerName;
    }
    if (buyerId && !buyerName) {
        return buyerId;
    }
    return deaultBuyerElement(buyerName, buyerId);
};
export var buildName = function (firstName, lastName, buyerName, buyerId) {
    if (buyerName || buyerId) {
        return createBuyerElement(buyerName, buyerId).toString();
    }
    return "".concat(firstName || '', " ").concat(lastName || '');
};
